import { render, staticRenderFns } from "./FormatKeirekishoList.vue?vue&type=template&id=453c3a5a&scoped=true"
import script from "./FormatKeirekishoList.vue?vue&type=script&lang=js"
export * from "./FormatKeirekishoList.vue?vue&type=script&lang=js"
import style0 from "./FormatKeirekishoList.vue?vue&type=style&index=0&id=453c3a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c3a5a",
  null
  
)

export default component.exports